import { valueToBigNumber } from './bignumber';
export const SECONDS_PER_YEAR = valueToBigNumber('31536000');
export const USD_DECIMALS = 8;
export const WEI_DECIMALS = 18;
export const RAY_DECIMALS = 27;
export const LTV_PRECISION = 4;
//# sourceMappingURL=constants.js.map